<template>
  <div class="toast-container">
    <BottomRightToastItem v-for="toast in toastList" :key="toast.id" :toast="toast" />
  </div>
</template>

<script>
import BottomRightToastItem from './BottomRightToastItem.vue'

export default {
  components: { BottomRightToastItem },
  data () {
    return {
      toastList: []
    }
  },
  methods: {
    addMessage ({ title, content, link }) {
      const id = Date.now() + Math.random()
      const visibleTime = 3000 // toast 顯示時間為 3 秒
      this.toastList.push({ id, title, content, link })
      setTimeout(() => {
        this.toastList = this.toastList.filter(toast => toast.id !== id) // 移除該則 toast
      }, visibleTime)
    }
  }
}
</script>

<style scoped>
.toast-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 5000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
</style>
